<div class="donut-card">
    <div class="donut-card-header">
        <div>
            <div class="donut-title">{{ 'new_entries.manipulation_type_frequency' | translate }}</div>
            <div class="donut-subtitle">{{ 'new_entries.monthly_count_of_submissions_with_each_type_of_manipulation' |
                translate }}</div>
        </div>
        <div class="donut-filters">
            <label>{{ 'new_entries.year' | translate }}</label>
            <select [(ngModel)]="selectedYear" (change)="onYearChange()">
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
        </div>
    </div>
    <div class="donut-chart-container">
        <apx-chart [series]="series" [chart]="chart" [xaxis]="xaxis" [yaxis]="yaxis" [plotOptions]="plotOptions"
            [dataLabels]="dataLabels" [colors]="colors"></apx-chart>
    </div>
</div>